import { aircraftByCustomerQuery } from "@common/api/aircraft"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { SubHeader } from "@/components/page/section"
import { CustomerAircraftTable } from "@/routes/_layout/customer_/$customerId/-components/customer-aircraft-table"

export const Route = createFileRoute("/_layout/customer_/$customerId/aircraft")(
  {
    staticData: { breadcrumb: "Aircraft" },
    loader: ({ context: { queryClient }, params: { customerId } }) =>
      queryClient.ensureQueryData(
        aircraftByCustomerQuery({ customer_id: customerId }),
      ),
    component: CustomerAircraft,
  },
)

function CustomerAircraft() {
  const { customerId } = useParams({
    from: "/_layout/customer_/$customerId/aircraft",
  })

  return (
    <div className="min-w-0 flex-1 overflow-y-auto bg-background pb-6">
      <SubHeader title="Aircraft" />
      <CustomerAircraftTable customerId={customerId} />
    </div>
  )
}
